import { Typography, TableCell } from '@mui/material';
import Moment from 'react-moment';
import StatusPill from 'Components/StatusPill.tsx/StatusPills';

const Cell: React.FC<{
  content?: string | number;
  status?: string;
  date?: string;
  email?: string;
}> = ({ content, status, date, email }) => (
  <TableCell style={{ padding: '16px 0', borderBottomColor: 'rgba(2, 15, 42, 0.20)' }}>
    {content && (
      <Typography variant="h5" color="#222222" mb="-5px">
        {content}
      </Typography>
    )}
    {email && (
      <Typography variant="h5" color="#222222" mb="-5px" textTransform="lowercase">
        {email}
      </Typography>
    )}
    {status && <StatusPill status={status} />}
    {date && (
      <Typography variant="h5" color="#222222" mb="-5px">
        <Moment format="DD/MM/YYYY">{date}</Moment>
      </Typography>
    )}
  </TableCell>
);

export default Cell;
